import React from 'react'

function Map() {
  return (
   <section className="map-section">
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3924.621716369489!2d77.96518091088029!3d10.37210078971043!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00aa8f24fedea7%3A0x555c80c099e47578!2sYamaha%20-%20Kanmani%20Moto%20Bikes!5e0!3m2!1sen!2sin!4v1711946233125!5m2!1sen!2sin" width="100%" height="250" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
   </section>
  )
}

export default Map;